import { collection, getDocs } from 'firebase/firestore';
import { firestore } from '../firebase';

// Action types
export const CATEGORY_LIST_REQUEST = 'CATEGORY_LIST_REQUEST';
export const CATEGORY_LIST_SUCCESS = 'CATEGORY_LIST_SUCCESS';
export const CATEGORY_LIST_FAIL = 'CATEGORY_LIST_FAIL';

// Fetch categories with icons from Firestore
export const listCategories = () => async (dispatch) => {
    dispatch({ type: CATEGORY_LIST_REQUEST });
    
    try {
        const categoriesRef = collection(firestore, 'CATEGORIES');
        const querySnapshot = await getDocs(categoriesRef);
        
        let categories = [];
        if (!querySnapshot.empty) {
            querySnapshot.forEach((doc) => {
                categories.push({
                    id: doc.id,
                    ...doc.data()
                });
            });
        }
        
        dispatch({ 
            type: CATEGORY_LIST_SUCCESS, 
            payload: categories 
        });
        
    } catch (error) {
        dispatch({ 
            type: CATEGORY_LIST_FAIL, 
            payload: error.message 
        });
    }
};

// Helper function to get category icon URL by category name
export const getCategoryIconFromData = (categoryName, categoriesData) => {
    if (!categoriesData || categoriesData.length === 0) return null;
    
    const category = categoriesData.find(cat => 
        cat.categoryName && cat.categoryName.toLowerCase() === categoryName.toLowerCase()
    );
    
    return category ? category.icon : null;
};
